<template>
  <div class="file">
    <input
      type="file"
      @change="setFile"
      :accept="(typeof data.accept === 'string' ? data.accept : '.pdf')"
      @focus="focus = true"
      @blur="focus = false"
      :class="{complete: data.error === '', notnull: value}"
      />
    <div class="title">
      {{ data.label || '' }}
    </div>
    <div class="fileName">
      {{ value ? value.slice(0, 20) : data.placeholder && focus ? data.placeholder : '' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
      value: null,
      error: null,
      complete: false,
      focus: false
    }
  },
  methods: {
    setFile (e) {
      const th = this;
      let reader = reader = new FileReader();
      reader.onload = function() {
        th.value = e.target.files[0].name
        th.$emit('set', { name: e.target.files[0].name, value: reader.result })
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  },
  mounted () {
    this.typeInput = this.data.type === 'number' ? 'text' : this.data.type
    this.error = this.data.error || ''
    this.value = this.data.value ? this.data.value.name : null
  }
}
</script>

<style lang="scss" scoped>
.file{
  @include box(100%, 3.5vw, relative, 0, 0, null, null, 0, null);
  @include flex(center, center, column);
  @include padding(0, 1vw, 0, 0);
  .title{
    @include box(100%, 2.5vw, absolute, 0, 1vw, null, null, 0, null);
    @include text(0.85vw, 400, null, null, left, $inputLabel);
    @include flex(left, center, row);
  }
  input{
    @include box(100%, 100%, absolute, 0, 0, null, null, null, null);
    z-index: 5;
    opacity: 0;
    cursor: pointer;
    &:focus + .title{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
    &.notnull + .title{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
  }
  .fileName{
    @include box(100%, 2.5vw, relative, 0, 0, null, null, 0, $input);
    @include border(null, solid, $inputBorder, null, null, null, 0.06vw);
    @include text(0.8vw, 400, null, null, left, $inputColor);
    @include flex(left, center, row);
    padding: 0;
    z-index: 2;
    padding-right: 2vw;
  }
}
</style>
